const images = [
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521326-60880234-e92a-4f1e-9432-05a9b14e3f67.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521327-028324be-0f19-4b7c-891b-7b0bc00a2f96.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521328-17e9c1ab-6744-472e-8775-d29a50a5a60b.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521341-9e90b88e-923b-4e0c-a3fa-dcb3a7950a77.jpeg",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521347-335a6fed-67b4-4a0d-b20f-ef5f48ddd3e8.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521348-f4fdf012-5d9a-4c79-b690-c9962f73b32a.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521350-f6435916-aac0-4fe7-8e80-44a37ee498e3.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521352-ca832267-030a-4679-9981-3a04a10ccc1e.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521354-e38b17c1-7c7b-4267-9187-b6ba2c14dcc9.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521355-7a68d5ea-0f73-4460-a121-f396b2a834ae.jpeg",
        "imgCateogry": "Gym"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521359-a46ebe13-0f84-4b0e-a940-e6779afbcc14.jpeg",
        "imgCateogry": "Infrastructure"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/184521361-3e1ca08e-33a8-4ed5-9924-37f57ca974e6.jpeg",
        "imgCateogry": "Infrastructure"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/189483276-4972ea40-2c2f-43d3-8b73-45457de26152.JPG",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/189483277-334e14ef-531f-4460-b377-c46e0769e76e.JPG",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/189483280-71499144-3dd7-4147-8b26-ebe6991aa228.JPG",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/189483282-76af849f-48e1-455a-9c74-98b6e8e305d1.JPG",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901222-7c48220f-bf6e-4d4b-bf0f-20e6769f4c7e.jpeg",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769135-de08ba5b-dc66-479d-8307-99d0d3857268.jpeg",
        "imgCateogry": "Food"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901243-469ed7c4-5dd0-46b7-8231-3d5cc9f84769.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901245-ddc54919-e7ba-4ea1-b32b-08c78bdba908.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901248-db4cff35-700c-4c02-9a9a-c97a3dbc4ff4.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901251-f0fd4e15-7bc9-445c-a851-bac04d5da26d.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769146-bff0d137-d5c1-4157-9494-99d417c8da99.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769150-067e560e-67da-4e70-b234-459bddfd9d81.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769151-85530a33-a831-42e5-b473-43adc6e94503.jpeg",
        "imgCateogry": "Campus Experience"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901218-9a48eb8e-7cdd-4343-853c-5011aa934b70.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901224-b4c3e143-a895-4815-b2d5-58ef8891905b.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901226-004d19d5-287d-4952-9336-9579ce08a08f.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901228-647dcc28-442e-429a-aad3-1399ea3c60b1.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901230-93bcd2ec-dc25-459e-8c61-83eac2898d6e.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901233-c892e56f-483c-4f27-b012-c29407543c62.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901236-2c557846-b8f5-46ae-bc6e-25cd49b8687f.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/190901241-db0692ed-aa6c-4ddd-b2b1-34ad8c333a1b.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769142-6177f930-27a2-406b-989b-a456757106d9.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/194769143-34ae6426-0849-4bbb-8b4e-707b242d06ab.jpeg",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/196045510-dc681fee-41cb-4c35-9f32-77d6c5cd0927.png",
        "imgCateogry": "Event"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573548-68ad2c6a-f21c-4706-b6fb-11b297e147a7.jpeg",
        "imgCateogry": "Library"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573565-d39f0657-6e42-473b-a6bc-fce02f4d2ed4.jpeg",
        "imgCateogry": "Library"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573578-168ffd3a-17a8-4dfd-8c18-8bb7d61a7f9a.jpeg",
        "imgCateogry": "Library"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573588-a40c2ac1-0a3f-4fc8-9e11-e46980614daa.jpeg",
        "imgCateogry": "Library"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573598-020114f1-236c-4fe0-8a5f-33f319c9ba6c.jpeg",
        "imgCateogry": "Library"
    },
    {
        "imgSource": "https://user-images.githubusercontent.com/87645745/191573610-cc005836-39a3-4edf-8151-0c6349f25a43.jpeg",
        "imgCateogry": "Library"
    }
]

export default images;